import React from 'react';
import SEO from '../../../components/SEO/SEO';

import { Link } from 'react-router-dom';
import './Ecommerce.css';

const Ecommerce = () => {
    return (
        <div className="industry-page">
            <SEO 
                title="Ecommerce Services | Digi Network" 
                description="Learn more about our Ecommerce services to grow your business online with Digi Network." 
                canonical="/industries/ecommerce/ecommerce" 
            />

            <section className="industry-hero">
                <div className="industry-hero-bg"></div>
                <div className="container">
                    <div className="industry-hero-content">
                        <div className="label">E-commerce Industry</div>
                        <h1>Digital Marketing for E-commerce</h1>
                        <p>Drive traffic, increase conversions, and grow your online store with data-driven digital marketing strategies that turn browsers into buyers. We understand the unique challenges e-commerce businesses face in today's competitive online marketplace.</p>
                        <div className="industry-hero-cta">
                            <Link to="/contact" className="btn btn-primary">
                                Get Started
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </Link>
                            <Link to="/case-studies" className="btn btn-outline">View Results</Link>
                        </div>
                    </div>
                </div>
            </section>

            <section className="hero-image-section">
                <div className="container">
                    <div className="image-placeholder-large">
                        <p>📷 Add E-commerce Hero Image (1200x500px)</p>
                    </div>
                </div>
            </section>

            <section className="industry-services">
                <div className="container">
                    <h2>E-commerce Marketing Services</h2>
                    <p className="section-intro">Comprehensive marketing solutions tailored for online stores</p>
                    <div className="services-grid">
                        <div className="service-card">
                            <h3>E-commerce SEO</h3>
                            <p>Rank for product keywords, category pages, and drive organic traffic that converts into sales. Our e-commerce SEO strategies help your products rank higher in search results and attract qualified shoppers.</p>
                            <ul>
                                <li>Product page optimization</li>
                                <li>Category page SEO</li>
                                <li>E-commerce schema markup</li>
                                <li>Technical SEO for online stores</li>
                                <li>Product review optimization</li>
                                <li>Site speed optimization</li>
                            </ul>
                            <Link to="/industries/e-commerce/seo" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>E-commerce Paid Ads</h3>
                            <p>Drive qualified traffic and sales with high-converting paid advertising campaigns across all platforms. Our targeted ad campaigns reach shoppers at every stage of their buying journey.</p>
                            <ul>
                                <li>Google Shopping campaigns</li>
                                <li>Facebook & Instagram ads</li>
                                <li>TikTok advertising</li>
                                <li>Retargeting campaigns</li>
                                <li>Dynamic product ads</li>
                                <li>Conversion tracking & optimization</li>
                            </ul>
                            <Link to="/industries/e-commerce/paid-ads" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>E-commerce Website Development</h3>
                            <p>Fast, conversion-optimized online stores that provide exceptional user experience and drive sales. Our e-commerce websites are designed to maximize conversions and provide seamless shopping experiences.</p>
                            <ul>
                                <li>WooCommerce development</li>
                                <li>Shopify store optimization</li>
                                <li>Custom e-commerce solutions</li>
                                <li>Conversion rate optimization</li>
                                <li>Mobile-first design</li>
                                <li>Checkout optimization</li>
                            </ul>
                            <Link to="/industries/e-commerce/web-development" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>E-commerce Email Marketing</h3>
                            <p>Recover abandoned carts, drive repeat purchases, and build customer loyalty with automated email campaigns. Our email marketing strategies help you stay top-of-mind with customers and drive repeat sales.</p>
                            <ul>
                                <li>Abandoned cart recovery</li>
                                <li>Product recommendation emails</li>
                                <li>Post-purchase sequences</li>
                                <li>Customer loyalty programs</li>
                                <li>Seasonal campaigns</li>
                                <li>Win-back campaigns</li>
                            </ul>
                            <Link to="/industries/e-commerce/email-marketing" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>E-commerce CRM & Automation</h3>
                            <p>Automate customer journeys, manage orders, and personalize experiences with GoHighLevel for e-commerce. Streamline your operations and provide personalized experiences at scale.</p>
                            <ul>
                                <li>Customer journey automation</li>
                                <li>Order management integration</li>
                                <li>Personalized marketing campaigns</li>
                                <li>Customer segmentation</li>
                                <li>Inventory alerts</li>
                                <li>Customer service automation</li>
                            </ul>
                            <Link to="/industries/e-commerce/all-in-one" className="service-link">Learn More →</Link>
                        </div>
                    </div>
                </div>
            </section>

            <section className="process-section">
                <div className="container">
                    <h2 className="process-item-title">Our E-commerce Marketing Process</h2>
                    <p className="section-intro">A proven methodology designed specifically for online stores</p>
                    <div className="process-grid">
                        <div className="process-item">
                            <div className="process-number">1</div>
                            <h3>Store Analysis</h3>
                            <p>We analyze your online store, product catalog, and customer behavior to identify optimization opportunities. Our team conducts comprehensive audits of your current performance and competitive landscape.</p>
                        </div>
                        <div className="process-item">
                            <div className="process-number">2</div>
                            <h3>Strategy Development</h3>
                            <p>We develop a customized marketing strategy that aligns with your business goals and target audience. Every tactic is designed to drive traffic, increase conversions, and maximize revenue.</p>
                        </div>
                        <div className="process-item">
                            <div className="process-number">3</div>
                            <h3>Implementation</h3>
                            <p>We implement the marketing strategy across all channels, from SEO to paid ads to email marketing. Our team handles everything from product page optimization to ad campaign launches.</p>
                        </div>
                        <div className="process-item">
                            <div className="process-number">4</div>
                            <h3>Optimization & Growth</h3>
                            <p>We continuously monitor performance, analyze customer data, and optimize campaigns for better results. Regular reporting keeps you informed of your marketing ROI and sales growth.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="image-section">
                <div className="container">
                    <div className="image-placeholder-medium">
                        <p>📷 Add E-commerce Process Image (1200x400px)</p>
                    </div>
                </div>
            </section>

            <section className="why-choose">
                <div className="container">
                    <h2>Why E-commerce Brands Choose Digi Network</h2>
                    <p className="why-intro">Trusted by online stores across the UAE and internationally</p>
                    <div className="why-grid">
                        <div className="why-item">
                            <div className="why-number">01</div>
                            <h3>Revenue-Focused</h3>
                            <p>Every strategy is designed to drive sales and increase average order value, not just traffic. We understand that e-commerce success is measured in revenue, not just website visits.</p>
                        </div>
                        <div className="why-item">
                            <div className="why-number">02</div>
                            <h3>E-commerce Expertise</h3>
                            <p>We understand online shopping behavior and create campaigns that convert browsers into buyers. Our team has extensive experience working with online stores across various industries.</p>
                        </div>
                        <div className="why-item">
                            <div className="why-number">03</div>
                            <h3>Proven Results</h3>
                            <p>We've helped e-commerce brands increase revenue by 400%+ through data-driven marketing strategies. Our data-driven approach delivers measurable results that directly impact your bottom line.</p>
                        </div>
                        <div className="why-item">
                            <div className="why-number">04</div>
                            <h3>Full-Funnel Approach</h3>
                            <p>From awareness to conversion to retention, we optimize every stage of the customer journey. We understand that e-commerce success requires a holistic approach to marketing.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="benefits-section">
                <div className="container">
                    <h2>Key Benefits for E-commerce Businesses</h2>
                    <p className="section-intro">How our marketing services help you grow your online store</p>
                    <div className="benefits-grid">
                        <div className="benefit-item">
                            <h3>Increased Traffic</h3>
                            <p>Drive more qualified traffic to your online store through SEO, paid ads, and social media marketing. Our multi-channel approach ensures you reach customers wherever they are.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Higher Conversion Rates</h3>
                            <p>Optimize your website and product pages to convert more visitors into customers. Our conversion rate optimization strategies help you maximize every visitor.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Better Customer Retention</h3>
                            <p>Build lasting relationships with customers through email marketing and loyalty programs. Turn one-time buyers into repeat customers and brand advocates.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Reduced Cart Abandonment</h3>
                            <p>Recover abandoned carts with automated email campaigns that remind customers to complete their purchase. Turn lost sales into successful conversions.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Improved ROI</h3>
                            <p>Track every marketing dollar and understand which channels deliver the best results. Make data-driven decisions about your marketing spend.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Competitive Advantage</h3>
                            <p>Stay ahead of competitors with cutting-edge marketing strategies and technology. Many e-commerce stores still rely on basic marketing methods.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="image-section">
                <div className="container">
                    <div className="image-placeholder-medium">
                        <p>📷 Add E-commerce Benefits Image (1200x400px)</p>
                    </div>
                </div>
            </section>

            <section className="industry-cta">
                <div className="container">
                    <h2>Ready to Grow Your E-commerce Store?</h2>
                    <p>Let's discuss how we can help you drive more traffic, increase conversions, and grow your online revenue.</p>
                    <Link to="/contact" className="btn btn-primary">
                        Book a Free Consultation
                        <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white"/>
                        </svg>
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default Ecommerce;
